export const TestIds = {
  bubble: 'user-bubble',
  message: 'user-bubble-message',
  copyButton: 'user-bubble-copy-button',
  timestamp: 'user-bubble-timestamp',
};
